import React, { useContext, useEffect } from 'react';
import { css } from '@emotion/css';
import AppLabels from '../../utils/appLabels';
import appLabels from '../../utils/appLabels';
import { invoke } from 'lodash';
import { ItemsContext, ItemsContextType } from '../ScheduledItems/ItemsContext';
import { isMobile } from '../../utils/utils';

const firstTextStyle = css`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 1.5rem;
`;

const secondTextStyle = css`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 1rem;
`;

const firstLinkStyle = css`
  font-weight: 600;
  line-height: 1.5rem;
  color: #7b1a27 !important;
  text-decoration-line: underline !important;
`;
const UserWithNoActiveOrders = () => {
  const currentItemsContext = useContext(ItemsContext) as ItemsContextType;

  useEffect(() => {
    // TODO: check why we needed this. Removing it since to be able to show this component we have to already have called this service
    //  so we should already have whatever data this was trying to fetch
    invoke(currentItemsContext, 'fetchItemsInfo');
  }, []);

  const analyticsEvents = (name) => {
    try {
      if (window['AB']?.DATALAYER) {
        window['AB'].DATALAYER.analyticsCTATracking(name);
      }
    } catch (error) {
      // Handle any errors that occur during execution
      console.error('@AnalyticsTeam error:', error);
    }
  };

  return (
    <>
      <div className={firstTextStyle}>
        <p>{AppLabels.UserWithNoActiveOrders.headLine}</p>
      </div>

      <div className={secondTextStyle}>
        {isMobile() ? (
          <p>
            {appLabels.UserWithNoActiveOrders.description} {appLabels.UserWithNoActiveOrders.ctaTitle}{' '}
          </p>
        ) : (
          <p>
            {appLabels.UserWithNoActiveOrders.description}{' '}
            <a
              onClick={() => analyticsEvents('cta:upcoming-orders-previous-enrolled|link|shop-now-schedule-and-save')}
              href={appLabels.UserWithoutSubscription.shopLink}
              className={firstLinkStyle}
            >
              {appLabels.UserWithNoActiveOrders.ctaTitle}
            </a>{' '}
          </p>
        )}
      </div>
    </>
  );
};

export default UserWithNoActiveOrders;
